import PalletEditList from "./palletEditList";

export default PalletEditList;
